import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    heading: "Poppins",
    text: "Poppins",
  },
  breakpoints: {
    mediumsmall: "800px",
  },
});

export default theme;
